// import BlogEditor from "./BlogEditor";
import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProjectPanelPost from "./ProjectPanelPost";
import axios from 'axios';

const ProjectCompletePanel = () => {
	const [formData, setFormData] = useState({
		project_name: "",
		project_content: "",
	});

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value,
		});
	};

	const handleContentChange = (data) => {
		setFormData((prevData) => ({
			...prevData,
			project_content: data,
		}));
	};

	const handleSubmit = async (e) => {
		const response = { status: 200 };
		e.preventDefault();
		try {
			const response = await axios.post(`/website/projectform/`, formData);
			console.log(formData);

			if (response.status === 200) {
				toast.success("Project has been submitted successfully!", {
					position: "top-center",
					autoClose: 2000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					progress: undefined,
				});

				setFormData({
					project_name: "",
					project_content: "",
				});
				window.scrollTo({ top: 0, behavior: "smooth" });
			} else {
				toast.error(
					"Failed to submit. Check your connection and retry.",
					{
						position: "top-center",
						autoClose: 2000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: false,
						draggable: true,
						progress: undefined,
					}
				);
			}
		} catch (error) {
			toast.error(
				"Internal Server Error! Unable to submit. Try again in some time.",
				{
					position: "top-center",
					autoClose: 2000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					progress: undefined,
				}
			);
		}

		// Add your submit logic here, e.g., sending data to the server
	};

	return (
		<>
			<div className="flex justify-start items-center h-auto py-12 pb-20 bg-[#f0f5fa] px-56">
				<ToastContainer />
				<div className="bg-white p-8 mt-20 rounded-lg shadow-lg w-full py-10 px-14">
					<h1 className="text-3xl font-bold mb-4">
						Submit a New <span className="mainred"> Project</span>
					</h1>
					<p className="text-gray-600 mb-8">
						Fill out the form below to submit a new project.
					</p>

					<form onSubmit={handleSubmit}>
						<div className="mb-6">
							<label className="block font-medium text-gray-700 mb-2">
								Project Name
							</label>
							<input
								type="text"
								className="block w-full border border-gray-300 rounded-lg p-2 px-3 outline-none focus:ring-2 focus:ring-[#333333]"
								placeholder="Enter project name"
								name="project_name"
								value={formData.project_name}
								onChange={handleChange}
								required
							/>
						</div>
						<div className="mb-6">
							<label className="block font-medium text-gray-700 mb-2">
								State
							</label>
							<input
								type="text"
								className="block w-full border border-gray-300 rounded-lg p-2 px-3 outline-none focus:ring-2 focus:ring-[#333333]"
								placeholder="Enter project name"
								name="project_name"
								value={formData.project_name}
								onChange={handleChange}
								required
							/>
						</div>
						<div className="mb-6">
							<label className="block font-medium text-gray-700 mb-2">
								Project Name
							</label>
							<input
								type="text"
								className="block w-full border border-gray-300 rounded-lg p-2 px-3 outline-none focus:ring-2 focus:ring-[#333333]"
								placeholder="Enter project name"
								name="project_name"
								value={formData.project_name}
								onChange={handleChange}
								required
							/>
						</div>
						<div className="mb-6">
							<label className="block font-medium text-gray-700 mb-2">
								Project Name
							</label>
							<input
								type="text"
								className="block w-full border border-gray-300 rounded-lg p-2 px-3 outline-none focus:ring-2 focus:ring-[#333333]"
								placeholder="Enter project name"
								name="project_name"
								value={formData.project_name}
								onChange={handleChange}
								required
							/>
						</div>
						<div className="mb-6">
							<label className="block font-medium text-gray-700 mb-2">
								Project Name
							</label>
							<input
								type="text"
								className="block w-full border border-gray-300 rounded-lg p-2 px-3 outline-none focus:ring-2 focus:ring-[#333333]"
								placeholder="Enter project name"
								name="project_name"
								value={formData.project_name}
								onChange={handleChange}
								required
							/>
						</div>
						<div className="mb-6">
							<label className="block font-medium text-gray-700 mb-2">
								Project Name
							</label>
							<input
								type="text"
								className="block w-full border border-gray-300 rounded-lg p-2 px-3 outline-none focus:ring-2 focus:ring-[#333333]"
								placeholder="Enter project name"
								name="project_name"
								value={formData.project_name}
								onChange={handleChange}
								required
							/>
						</div>
						

						<div className="mb-6">
							<label className="block font-medium text-gray-700 mb-2">
								Project Content
							</label>
							{/* <BlogEditor onChange={handleContentChange} /> */}
						</div>

						<div className="mt-14 text-center">
							<button
								type="submit"
								className="w-full bg-[#990000] text-white p-2 py-3 text-lg rounded-lg hover:bg-[#b80202] transition-colors"
							>
								Submit Project
							</button>
						</div>
					</form>
				</div>
			</div>
			<ProjectPanelPost />
		</>
	);
};

export default ProjectCompletePanel;
